import { render, staticRenderFns } from "./connection-jobtip.vue?vue&type=template&id=2671c812&scoped=true&"
import script from "./connection-jobtip.ts?vue&type=script&lang=ts&"
export * from "./connection-jobtip.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671c812",
  null
  
)

export default component.exports